export default [
  {
    path: "/",
    name: "HomeIndex",
    component: () => import("@/views/index.vue"),
    redirect: "/homePage",
    children: [
      {
        path: "homePage",
        name: "HomePage",
        component: () => import("@/views/SIBI/homePage/index.vue"),
        meta: {
          type: "tabbar",
          title: "首页",
          url: require("@/assets/image/SIBI/tabbar/icon_tab_sy_c@2x.png"),
          activeUrl: require("@/assets/image/SIBI/tabbar/icon_tab_sy_o@2x.png"),
        },
      },
      {
        path: "bondPage",
        name: "bondPage",
        component: () => import("@/views/SIBI/bondPage/index.vue"),
        meta: {
          type: "tabbar",
          title: "生态合成",
          url: require("@/assets/image/SIBI/tabbar/icon_tab_bd_c@2x.png"),
          activeUrl: require("@/assets/image/SIBI/tabbar/icon_tab_bd_o@2x.png"),
        },
      },
      {
        path: "myBond",
        name: "myBond",
        component: () => import("@/views/SIBI/bondPage/myBond.vue"),
        meta: {
          title: "我的订单",
        },
      },
      {
        path: "bondDetails",
        name: "bondDetails",
        component: () => import("@/views/SIBI/bondPage/bondDetails.vue"),
        meta: {
          title: "订单详情",
        },
      },
      {
        path: "promotionPage",
        name: "promotionPage",
        component: () => import("@/views/SIBI/promotionPage/index.vue"),
        meta: {
          type: "tabbar",
          title: "团队",
          url: require("@/assets/image/SIBI/tabbar/icon_tab_td_c@2x.png"),
          activeUrl: require("@/assets/image/SIBI/tabbar/icon_tab_td_o@2x.png"),
        },
      },
      {
        path: "miningPage",
        name: "miningPage",
        component: () => import("@/views/SIBI/miningPage/index.vue"),
        meta: {
          type: "tabbar",
          title: "资金管理",
          url: require("@/assets/image/SIBI/tabbar/icon_tab_zcgl_c@2x.png"),
          activeUrl: require("@/assets/image/SIBI/tabbar/icon_tab_zcgl_o@2x.png"),
        },
      },
      {
        path: "lpStaking",
        name: "lpStaking",
        component: () => import("@/views/SIBI/lpStaking/index.vue"),
        meta: {
          type: "tabbar",
          title: "lpStaking.title",
          url: require("@/assets/image/SIBI/tabbar/icon_tab_lp_c.svg"),
          activeUrl: require("@/assets/image/SIBI/tabbar/icon_tab_lp_o.svg"),
        },
      },
      {
        path: "lpStaking/records",
        name: "lpStakingRecords",
        component: () => import("@/views/SIBI/lpStaking/records.vue"),
        meta: { title: "lpStaking.records" },
      },
      {
        path: "lpStaking/ranking",
        name: "lpStakingRanking",
        component: () => import("@/views/SIBI/lpStaking/ranking.vue"),
        meta: { title: "lpStaking.ranking" },
      },
      {
        path: "lpStaking/earnings",
        name: "lpStakingEarnings",
        component: () => import("@/views/SIBI/lpStaking/earnings.vue"),
        meta: { title: "lpStaking.earnings" },
      },
      {
        path: "myPledge",
        name: "myPledge",
        component: () => import("@/views/SIBI/miningPage/myPledge.vue"),
        meta: {
          title: "资金明细",
        },
      },
    ],
  },
];
